import React from 'react';
import 'pages/EventList/style.css';
// import Col from 'react-bootstrap/Col';
// import Form from 'react-bootstrap/Form';
// import Row from 'react-bootstrap/Row';
// import PKimg from 'Assets/check-done-final-ok.png';
// import facebook from 'Assets/facebook.svg';
// import twitter from 'Assets/twitter.svg';
// import { CopyToClipboard } from 'react-copy-to-clipboard';
//import EventListTable from 'components/EventListTable/EventListTable';
import EventListTableV2 from 'components/EventListTable/EventListTableV2';
import Table from 'react-bootstrap/Table';
import TableHeader from 'components/Table/TableHeaderV2';
import Button from 'components/Button/Button';
import { organization_user_access_level, user_account_level, user_Status_Ver, apiUrl, org_friendly_url, user_access_level, events_list_api, myHeaders_Auth_With_Cache_Control, user_entity_uuid } from "Api/Api";
// , channel_list_api, user_Status
import axios from "axios";
// import { dateConvert, unixDateConversion } from 'utils/Helper';
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import { local_routes } from 'utils/Routes';
// import { FacebookShareButton, TwitterShareButton, } from 'react-share';
import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
import { NavLink } from "react-router-dom";

import UserContext from 'store/UserContext';

//import _get from 'lodash/get';

export default class EventList extends React.Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.state = {
            table_loading: true,
            loading: true,
            events_get_from: 0,
            events_get_limit: 40,
            events_get_total: null,
            //events_array: [],
            events_page_number: 1,
            tableHeader: { 'Title': '', 'Date': '', 'Source': '', 'Published': '', 'Privacy': '', 'Assets': '', 'Edit': ''},
            events_array: [],
            //loading: true,
            
            source_info: props.source_info,
            channel_info: {},

        };
        
        this.workspace_base_url = "";
        if (org_friendly_url) {
            this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        }
        
        this.auto_refresh_time = 30; // seconds
    }
    
    APICalls = async (config = {}) => {
      console.log("EventList APICalls",config)
        let new_state = {...this.state};

        if ('events_get_from' in config) {
            new_state.events_get_from = config.events_get_from;
            //console.log(" YO",new_state.events_get_from)
        }
        if (config.events_page_number) {
            new_state.events_page_number = config.events_page_number;
        }
        
        // Must get channel_info before asking for all events
        //let channel_response = await axios.get(`${apiUrl}channels/${this.props.match.params.friendly_url}`,myHeaders_With_Cache_Control);

        //if (channel_response.data) {
            //new_state.channel_info = channel_response.data;
        //}        
        
        let api_promises = [];
        if (new_state.source_info.entity_type === 'users') {
            api_promises.push(axios.get(`${apiUrl}${new_state.source_info.entity_type}/${new_state.source_info.entity_uuid}/events?do_recursive=true&from=${new_state.events_get_from}&limit=${new_state.events_get_limit}&filter_obj=${encodeURIComponent('{"entity_owner_integer":{"gte":1},"status_code":{"ne":2}}')}&sort_obj=${encodeURIComponent('{"start_time":"desc"}')}`, myHeaders_Auth_With_Cache_Control));
        } else {
            api_promises.push(axios.get(`${apiUrl}${new_state.source_info.entity_type}/${new_state.source_info.entity_uuid}/events?do_recursive=true&from=${new_state.events_get_from}&limit=${new_state.events_get_limit}&filter_obj=${encodeURIComponent('{"status_code":{"ne":2}}')}&sort_obj=${encodeURIComponent('{"start_time":"desc"}')}`, myHeaders_Auth_With_Cache_Control));
        }
        
        let [events_response] = await Promise.all(api_promises);

        if (events_response.headers && events_response.headers['x-total-count']) {
            new_state.events_get_total = parseInt(events_response.headers['x-total-count'],10);
        }
        
        //let [events_response] = await Promise.all([
            //axios.get(`${apiUrl}channels/${new_state.channel_info.entity_uuid}/events?filter_obj=${encodeURIComponent('{"status_code":{"ne":2}}')}&sort_obj=${encodeURIComponent('{"created_time":"desc"}')}`, myHeaders_With_Cache_Control),
        //]);

        let tmp_events_array = [];
        for (let event_info of events_response.data) {
            if (!this.workspace_base_url && event_info.organizations_uuid) {
                new_state.events_get_total--;
                continue;
            }
            if (!event_info.public_status) {
                event_info.public_status = 'public';
            }
            event_info.editable = true;
            if (event_info.locations_text) {
              event_info.source_info = {entity_name:event_info.locations_text};
            } else if (event_info.channels_text) {
              event_info.source_info = {entity_name:event_info.channels_text};
            } else {
              // would be for organizations
              event_info.source_info = this.props.source_info;
            }
            tmp_events_array.push(event_info);
        }

        new_state.events_array = tmp_events_array;
        
        if (new_state.source_info.entity_type === 'locations' || new_state.source_info.entity_type === 'channels') {
            // for channels/locations, channel/location admin might not own the event
            for (let event_obj of new_state.events_array) {
                let editable = false;
                if (user_access_level === 'admin') {
                    editable = true;
                } else if (event_obj.users && event_obj.users.length > 0) {
                    editable = event_obj.users.some((item) => {
                        if (item.entity_uuid === user_entity_uuid && item.xref_data && item.xref_data.entity_owner_integer) {
                            return true;
                        }
                    });
                }
                event_obj.editable = editable;
            }
        } else if (new_state.source_info.entity_type === 'users') {
            // this is from My Events, so our match is different
            for (let event_obj of new_state.events_array) {
                let editable = false;
                if (user_access_level === 'admin') {
                    editable = true;
                } else if (event_obj.xref_data && event_obj.xref_data.entity_owner_integer) {
                    editable = true;
                }
            }
        } else {
            // this should be from org admin perspective - they can edit all org events
        }
        
        new_state.loading = false;
        new_state.table_loading = false;
        
        //console.log("EventList APICalls events_array",new_state.events_array);
        
        this.setState( new_state );
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentDidMount = async function () {
        await this.APICalls();
        this.interval = setInterval(() => this.APICalls(), this.auto_refresh_time * 1000);
    }

    OnChangePublishOption = async (publish_obj, eventData, event_index) => {
        console.log("OnChangePublishOption",publish_obj,eventData,event_index);
        
        /*
        let patch_obj = {
            //status_code: publish_obj.status_code
        }
        if (this.workspace_base_url || user_account_level === 'private') {
            patch_obj.public_status = publish_obj.public_status
        }
        */
        
        //await axios.patch(`${apiUrl}presentations/${presentationData.entity_uuid}`,patch_obj);
        let tmp_events_array = [...this.state.events_array];

        tmp_events_array[event_index].public_status = publish_obj.public_status;

        // bust cache if not draft
        //if (presentationData.status_code === 1) {
            //axios.get(`${presentation_Creation_API}/${presentationData.friendly_url}`, myHeaders_Auth_With_Cache_Control);
        //}
        this.setState({
            events_array: tmp_events_array
        });
    }



    togglePublish = async (status, eventData, event_index) => {
        let status_code = (status === true) ? 1 : (status === false) ? 4 : null;
        const payload = {
            status_code: status_code
        };
        if (status_code !== null && status_code !== undefined) {
           await axios.patch(`${events_list_api}/${eventData.entity_uuid}`, payload);
           let tmp_events_array = [...this.state.events_array];
           tmp_events_array[event_index].status_code = status_code;
           this.setState({
               events_array: tmp_events_array
           });
        }
    }

    OnDeleteEvent = async (event_uuid, event_index) => {
        let patch_obj = {
            status_code: 2
        };
        await axios.patch(`${apiUrl}events/${event_uuid}`,patch_obj);
        let tmp_events_array = [...this.state.events_array];
        tmp_events_array.splice(event_index,1); // remove from array
        this.setState({
            events_array: tmp_events_array
        });
    }    

    OnPaginateCallback = async (page_number) => {
        console.log("OnPaginateCallback",page_number);
        
        let tmp_from = (page_number - 1) * this.state.events_get_limit;
        console.log("OnPaginateCallback",page_number,tmp_from);
        this.setState({
           table_loading: true,
           events_get_from:tmp_from,
           events_page_number:page_number
        });
        await this.APICalls({events_get_from:tmp_from,events_page_number:page_number});
    }


    render() {
        if (this.state.loading) {
            return (
                <div className="createEventSpinner">
                    <ActivityIndicator theme="spinner" />
                </div>
            );
        }
        
        /*
        let tmp_referrer; tmp_referrer = `${this.workspace_base_url}${local_routes.managechannel}/${this.state.source_info.friendly_url}/events`;
        if (this.state.source_info === 'locations') {
          tmp_referrer = `${this.workspace_base_url}${local_routes.managecity}/${this.state.source_info.friendly_url}/events`;
        } else if (this.state.source_info === 'channels') {
          tmp_referrer = `${this.workspace_base_url}${local_routes.managechannel}/${this.state.source_info.friendly_url}/events`;
        } else if (this.state.source_info === 'organizations') {
          tmp_referrer = `${this.workspace_base_url}${local_routes.manageworkspace}/${this.state.source_info.friendly_url}/events`;
        }
        */
        
        return (
            <div style={{paddingTop: "0px"}}>
                {/* Events List Section Starts here */}
                <div className="editCitySec">
                    <div className="editCityMenu ">
                        <div className="pkListContainer eventListContainer">
                        
                            { this.state.source_info.entity_type !== 'users' &&
                              <div className="myPkList">
                                  <h2 className="myPkHeading">Events</h2>
                                  <div className="buttonS">
                                     <NavLink
                                          to={{
                                              pathname:`${this.workspace_base_url}${local_routes.manageevent}`,
                                              data: {
                                                  source: {
                                                      entity_type: this.state.source_info.entity_type,
                                                      entity_uuid: this.state.source_info.entity_uuid,
                                                      referrer: this.props.referrer
                                                  }
                                              }
                                            }}
                                      >
                                          <Button
                                              theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 pk-create">
                                              New Event
                                          </Button>
                                      </NavLink>
                                  </div>
                              </div>
                            }
                            
                            {
                                this.state.events_array.length === 0 &&
                                <div className="empty-event">
                                    <EmptyMessage empty_message="No events created yet!" />
                                </div>
                            }

                            {
                                this.state.events_array.length > 0 &&
                                <div style={{ width: "100%" }} className="table-boby channel-events-list">
                                    <Table variant={this.context.theme} responsive={true}>
                                        <tbody>
                                            
                                            <TableHeader
                                              theme={this.context.theme}
                                              tableHeader={this.state.tableHeader}
                                              displayed_list_length={this.state.events_array.length}
                                              total_list_length={this.state.events_get_total}
                                              current_page_number={this.state.events_page_number}
                                              from={this.state.events_get_from}
                                              limit={this.state.events_get_limit}
                                              OnPaginateCallback={this.OnPaginateCallback}
                                            />
                                            { this.state.table_loading &&
                                              <tr><td colSpan={Object.keys(this.state.tableHeader).length}><ActivityIndicator theme="button-Status-Loader justify-content-center" /></td></tr>
                                            }
                                            {
                                                !this.state.table_loading && this.state.events_array.map((item, i) => {
                                                    return (
                                                        <EventListTableV2
                                                            key={item.entity_uuid}
                                                            index={i} // so callbacks can easily change state to reflect actions
                                                            event_info={item}
                                                            
                                                            user_access_level={user_access_level}
                                                            organization_user_access_level={organization_user_access_level}
                                                            user_account_level={user_account_level}
                                                            user_status_code={user_Status_Ver}

                                                            
                                                            //source_info={{...this.state.source_info}}
                                                            //source_info={{...this.props.org_data,entity_type:'organizations'}}
                                                            
                                                            //org_info={this.props.org_data}
                                                            
                                                            //referrer={`${this.workspace_base_url}${local_routes.manageworkspace}/events`}
                                                            
                                                            //referrer={`${this.workspace_base_url}${local_routes.managechannel}/${this.state.channel_info.friendly_url}/events`}
                                                            referrer={this.props.referrer}
                                                            
                                                            workspace_base_url={this.workspace_base_url}
                                                            togglePublish={this.togglePublish}
                                                            OnDeleteEvent={this.OnDeleteEvent}
                                                            OnPaginateCallback={this.OnPaginateCallback}
                                                            OnChangePublishOption={this.OnChangePublishOption}
                                                        />
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                {/* Events List Esction Endds here */}
            </div>
        )

    }
   
}
